import { UserRoles } from '@/enums';
import { OrganizationShared } from '@/modules/organizations/shared/types';
import { SimpleEnumType } from '@/types';
import { Widget } from '@/components/widgets-menu/types';
import { News } from '@/modules/news/types';

export namespace User {
  export enum Pages {
    PROFILE = 'profile',
    CHANGE_PASSWORD = 'change-password',
    CHANGE_EMAIL = 'change-email',
  }

  export type AvailablePage = {
    [key: string]: unknown,
    name: string,
    slug: string,
    is_active: boolean
    info_message_index: string | null,
    info_message_detail: string | null,
  }

  export type Profile = {
    [key: string]: unknown;
    id?: number;
    company: string;
    is_shipping_stopped: boolean | null;
    name: string | null;
    surname: string | null;
    patronymic: string | null;
    image?: string | File | null;
    telephone: string;
    email: string;
    birth_date: string;
    city: string;
    password: string;
    partner_code: string;
    sigma_partner_code: string | null;
    frontol_partner_code: string | null;
    roles: SimpleEnumType<UserRoles.Internal | UserRoles.External>[];
    job_rank: string | null; // должность
    organization?: OrganizationShared;
    password_change_date?: string;
    widgets: Array<Widget>
    _login?: string;
    available_pages: AvailablePage[],
    io_user: string | null,
    io_company: string | null,
    main_menu: User.MainMenuItem[],
    favorites_menu?: User.MainMenuItem,
    help_menu?: User.MainMenuItem,
    last_news: News.News | null,
    constants: {
      const_max_cart_product_quantity_per_unit: number,
    }
    is_resident: boolean,
    today_events: number | null,
  }

  export type RegisterProfile = Profile & { invite: string }

  export interface PasswordApiUpdate {
    old_password: string,
    password: string,
  }

  export interface EmailValidationCodeApi {
    email: string,
    code: number,
  }

  export interface PageTag {
    id: number,
    page_id: number,
    name: string,
    color_name: string,
    color_area: string,
  }

  export type MainMenuItem = {
    id: number,
    title: string,
    slug: string,
    icon: string | null,
    frontend_link: string | null,
    is_favorite: boolean,
    parent: string | null,
    notifications?: number,
    sub_menu: MainMenuItem[],
    hover?: boolean,
    active?: boolean,
    tag: PageTag | null,
  }
}
